module.exports = __webpack_public_path__ + "img/verify.804a968c.png";